import type {ReactElement} from 'react';
import type {TrySeasonalFontButtonProps} from './try-seasonal-font-button.types';
import {SPECIAL_SEASON_NAME_TO_FONT_CATEGORY_ID_MAPPING} from './try-seasonal-font-button.types';
import {Button, ButtonType, ButtonSize} from '@Components/button';
import {TextSize} from '@Components/text';
import styles from './try-seasonal-font-button.module.scss';
import {WavyText} from '@Components/wavy-text/wavy-text';
import {ColorType} from '@Components/wavy-text/wavy-text.types';

import {getCurrentSeasonName, SeasonName} from '@Libraries/seasons.library';
import {SeasonalDecorationEmoji} from '@Utils/seasonal-promotion.util';

export function TrySeasonalFontButton({...props}: TrySeasonalFontButtonProps): ReactElement<any> | null {
  const currentSeasonName = getCurrentSeasonName();

  if (!currentSeasonName) {
    return null;
  }

  const getTextForSeasonName = (): string => {
    switch (currentSeasonName) {
      case SeasonName.HALLOWEEN:
        return window.i18next.t('pmwjs_try_halloween_fonts');
      case SeasonName.CHRISTMAS:
        return window.i18next.t('pmwjs_try_christmas_fonts');
      default:
        throw new Error(`Unhandled Season: ${currentSeasonName}`);
    }
  };

  const getEmojiForSeason = (): string => {
    switch (currentSeasonName) {
      case SeasonName.HALLOWEEN:
        return SeasonalDecorationEmoji.HALLOWEEN;
      case SeasonName.CHRISTMAS:
        return SeasonalDecorationEmoji.CHRISTMAS;
      default:
        throw new Error(`Unhandled Season: ${currentSeasonName}`);
    }
  };

  const getColorForSeason = (): ColorType => {
    switch (currentSeasonName) {
      case SeasonName.HALLOWEEN:
        return ColorType.HALLOWEEN;
      case SeasonName.CHRISTMAS:
        return ColorType.CHRISTMAS;
      default:
        throw new Error(`Unhandled Season: ${currentSeasonName}`);
    }
  };

  const getCustomText = (): ReactElement<any> => {
    return (
      <WavyText
        emojiText={getEmojiForSeason()}
        containerClassName={`spacing-m-l-2 ${styles.seasonalFontButtonText}`}
        colorType={getColorForSeason()}
        val={getTextForSeasonName()}
        size={TextSize.XSMALL}
        bold
      />
    );
  };

  return (
    <Button
      isFullWidth
      customText={getCustomText()}
      customClasses={'_full-width radius-8'}
      type={ButtonType.SECONDARY}
      size={ButtonSize.MEDIUM}
      onClick={() => {
        props.onClick({
          idfontcategory: SPECIAL_SEASON_NAME_TO_FONT_CATEGORY_ID_MAPPING[currentSeasonName],
          name: currentSeasonName,
        });
      }}
    />
  );
}
